<template>
  <div>
    <vggrid ref="xGrid" :random="Math.floor(Math.random() * 999999)" :list="pgCrossList"
            tableheight="600" flexname="" :cols="pgCols"
            :showfooter="false" :showPage="false" :resizable="true"  :mergeRow='mergeRow'>
      <template slot="btn">
        <div class="exscore-topbtn">
          <div class="exscore-topbtn-title">评审人[{{pexpert.pexpertname}}]的评分过程</div>
        </div>
      </template>
    </vggrid>

    <div class="split-line"></div>
    <div class="exscore-container">
      <vggrid :random="Math.floor(Math.random() * 999999)" :list="pgsList" flexname="" :cols="pgsCols"
              :showfooter="false" :showPage="false" :resizable="true"
              >
        <template slot="btn">
          <div class="exscore-topbtn">
            <div class="exscore-topbtn-title">评审人[{{pexpert.pexpertname}}]的评分汇总</div>
          </div>
        </template>
      </vggrid>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'
  export default {
    name: 'projectScoringComByEx',
    mixins: [common],
    components: {vggrid},
    props: {
      pexpert: {},
      projectid: {},
      pexpertid: {},
      activeName: {}
    },
    data () {
      return {
        // priceModel: '',
        project: {},
        list: [],
        scoreTotalList: [],
        selectList: [],
        pgsuList: [],
        psuComList: [],
        pgCrossList: [],
        pgsList: [],
        btnLoading: false,
        model: {},
        isEdit: true,
        mergeRow:['pgratio','pgparentname','pgchildname'],
        editRules: {},
        pgsCols: [
          {field: 'comfullname', fieldtype: 'C', title: '供应商', calculExpr: '', addNewRowFlg: false},
          // {field: 'pgspriceasexchange', fieldtype: 'C', title: '价格得分', calculExpr: '', addNewRowFlg: false, width: 100},
          {field: 'pgscommercialasexchange', fieldtype: 'C', title: '评审得分', calculExpr: '', addNewRowFlg: false, width: 100},
          // {field: 'pgstechnologyasexchange', fieldtype: 'C', title: '技术得分', calculExpr: '', addNewRowFlg: false, width: 100},
          // {field: 'pgsas', fieldtype: 'C', title: '总分', calculExpr: '', addNewRowFlg: false, width: 100},
          // {field: 'pgsdesc', fieldtype: 'C', title: '评分意见', calculExpr: '', editRender: { name: 'input'}},
        ],
        pgCols: []
      }
    },
    async created () {
      await this.getModel()
      this.getPgCols()
      await this.getPgsuCrossList()

    },
    watch: {
      async pexpertid () {
        this.getPgCols()
        await this.getPgsuCrossList()
      }
    },
    methods: {
      // 交叉表的数据
      async getPgsuCrossList () {
        this.pgCrossList = []
        this.loading = true
        let project = {}
        project.projectisqcheck = this.project.projectisqcheck
        let res = await request({
          method: 'get',
          url: '/expert/getPgCrossByProjectId',
          params: {
            projectid: this.projectid,
            pexpertid: this.pexpertid,
            psupqcesresult: 1,
            project:project
          }
        })
        // 价格项
        // let priceList = res.pgList.filter(v => +v.pgflg === 1)
        // this.priceModel = priceList.length ? priceList[0] : ''
        // 非价格项
        this.pgCrossList = res.pgList.filter(v => +v.pgflg === 2)
        // this.pgCrossList = res.pgList
        this.pgsuList = res.pgsuList
        this.psuComList = res.psuList
        // 构造合计行数据
        // this.setTotalRow(res)
        this.scoreTotalList = res.totalList
        await this.setCrossCols()
        await this.setPgsList()
        this.loading = false
      },
      // 构造合计行数据
      setTotalRow (res) {
        if (res.psuList.length) {
          let tree_total = res.tree.filter(v => +v.pgflg === 2)
          let totallist = res.pgsuList.filter(v => +v.pgflg === 2 && +v.pgsucomid == +res.psuList[0].psucomid)
          this.pgCrossList.push({
            pgparentname: '合计',
            pgratio: tree_total.map(t => Number(t.pgratio)).reduce((a, b) => a + b),
            pgscore: totallist.map(t => Number(t.pgscore)).reduce((a, b) => a + b)
          })
          res.psuList.forEach(com => {
            let comsuasList = this.pgsuList.filter(t => +t.pgsucomid === +com.psucomid && +t.pgflg === 2)
            this.pgsuList.push({
              pgsucomid: com.psucomid,
              pgsuas: comsuasList.map(t => Number(t.pgsuas)).reduce((a, b) => a + b),
              pgname: '合计'
            })
          })
        }
      },
      // 我的预审结论数据
      async setPgsList() {
        await this.getPgsList()
      },
      getPgCols () {
        if (+this.project.projectpgstotalrule === 1) {
          this.pgCols = [
            // {field: 'pgparentname', fieldtype: 'C', title: '项目', calculExpr: ''},
            // {field: 'pgratio', fieldtype: 'C', title: '分值(百分比)', calculExpr: '',width: 100, issum: 0},
            {field: 'pgchildname', fieldtype: 'C', title: '子项', calculExpr: ''},
            {field: 'pgchildchildname', fieldtype: 'C', title: '二级（评审内容）', calculExpr: ''},
            {field: 'pgremark', fieldtype: 'C', title: '评分档次及依据', calculExpr: ''},
            {field: 'pgscore', fieldtype: 'C', title: '分值', calculExpr: '',width: 80, issum: 0}
          ]
        } else {
          this.pgCols = [
            // {field: 'pgparentname', fieldtype: 'C', title: '项目', calculExpr: ''},
            // {field: 'pgratio', fieldtype: 'F', title: '分值(绝对值)', calculExpr: '',width: 100, triggercol:1, issum: 0},
            {field: 'pgchildname', fieldtype: 'C', title: '一级（项目）', calculExpr: ''},
            {field: 'pgchildchildname', fieldtype: 'C', title: '二级（评审内容）', calculExpr: ''},
            {field: 'pgremark', fieldtype: 'C', title: '评分档次及依据', calculExpr: ''},
            {field: 'pgscore', fieldtype: 'F', title: '分值', calculExpr: '',width: 80, issum: 0},
          ]
        }
      },
      // 设置交叉表的表头
      async setCrossCols () {
        if (this.psuComList.length) {
          for(let i=0;i<this.psuComList.length;i++) {
            let item = this.psuComList[i]
            this.pgCols.push({
              title:item.comfullname,
              children: [
                {
                  // title: item.appendfilename,
                  slots: {
                    default: 'default',
                    default: ({row}) => {
                      return this.getCrossScore({pgid: row.endpgid, psucomid: item.comid})
                    },
                    header: ({ column }) => {
                      return [
                        <span onClick={this.fileClick.bind(this,column,item)} style="color: #409EFF;padding-left:10px">{item.appendfilename}</span>
                    ]
                    }
                  }
                }
              ],
              showOverflow: true
            })
          }
        }
      },
      fileClick (col, item) {
        this.downFile(item.appendurl)
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.projectid}
        })
        this.project = res
      },
      // 获取已检查结果，把结果值说明返回交叉表
      getCrossScore (item) {
        let model = this.pgsuList.find(v => +v.pgsucomid === +item.psucomid && (+v.pgsupgid === +item.pgid || v.pgname === '合计'))
        return model ? model.pgsuas : ''
      },
      // 汇总表的数据
      async getPgsList () {
        this.pgsList = await request({
          url: 'expert/getPgsByProjectId',
          method: "get",
          params: {
            pexpertid: this.pexpertid,
            projectid: this.projectid
          }
        })
      }
    }
  }
</script>
<style lang="scss">
  .exscore-container {
    margin-top: 20px;
    .exscore-topbtn {
      display: flex;
      align-items: center;
      .exscore-topbtn-title {
        padding-left: 10px;
        text-align: center;
      }
      .exscore-topbtn-btn {
        padding-left: 20px;
      }
    }

  }
  .exscore-footbtn {
     text-align: right;
     padding-top: 10px;
   }
</style>
